///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.short_dated_opportunity = abcsetup.short_dated_opportunity || {};
abcsetup.short_dated_opportunity.common = abcsetup.short_dated_opportunity.common || {};

///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Variables
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.short_dated_opportunity.common.display_items = [];


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////

abcsetup.short_dated_opportunity.common = {

    /**
     * Bind any CRUD fields
     */
    bindFields: function() {
        // Open modal for new item
        $('#item-modal-open').on('click', function() {
            abcsetup.short_dated_opportunity.common.resetModalForm(true);
            $('#add_update_item').text('+ Add Item');
            $('#new-short-dated-item-search').parent().show();
            // $('#new-short-dated-item-modal h5').text('Add Short Dated Item');
            $('#new-short-dated-item-modal').modal('show');
        });

        // Open modal to edit item
        $(document).on('click', '.edit-item', function() {
            abcsetup.short_dated_opportunity.common.resetModalForm(false);
            var uid = $(this).data('id');
            var data = $('#hidden-field-'+uid).val();
            var data_array = data.split('&');
            var ndc = '';
            var product_name = decodeURIComponent(data.substring(data.indexOf('product_name=') + 13, data.indexOf('&form')));

            $('#add_update_item').text('Update Item');
            $('#new-short-dated-item-search').parent().hide();

            for (var i in data_array) {
                var keyVal = data_array[i].split('=');

                if (!keyVal.toString().includes(',')) {
                    continue;
                } else {
                    var key = keyVal[0];
                    var val = decodeURI(keyVal[1].trim());
                }

                if (key === 'new-short-dated-item-search') {
                    continue;
                }

                if (key === 'product_name') {
                    val = product_name;
                }

                if (key === 'ndc') {
                    ndc = val;
                }

                $('#new-short-dated-item-modal #'+key).val(val);
            }

            $('#new-short-dated-item-modal').modal('show');
        });

        // Make the import button disabled until a file has been selected
        $('#import_short_dated_items_file').on('change', function(){
            if ($(this)[0].files.length === 0) {
                $('#import_short_dated_items_button').addClass('disabled').prop('disabled', true);
            } else {
                $('#import_short_dated_items_button').removeClass('disabled').prop('disabled', false);
            }
        });

        // Items are being imported from an excel document
        $(document).on("click", "#import_short_dated_items_button", function () {
            abcsetup.blockUI(true);
            abcsetup.excel.readFile($("#import_short_dated_items_file")[0], function(data) {

                var rows = abcsetup.excel.toArray(data, abcsetup.short_dated_opportunity.common.column_map);

                if (data[0][0] !== 'SAP') {
                    abcsetup.alerts.show('Incorrect Template Detected', 'Please ensure that you are using the correct import template and try again.');
                    return;
                }

                // Loop through newly created rows to pop item into the UI
                let ndc_count = 0;
                let uid = new Date().getTime();
                for (let i in rows) {

                    if (rows[i].ndc.toString().length > 0) {
                        if (typeof rows[i].expiration_date !== 'undefined') {
                            var date_obj = new Date(rows[i].expiration_date);
                            var expiration_date = date_obj.getFullYear()+'-'+('0'+(date_obj.getMonth()+1)).slice(-2)+'-'+('0'+date_obj.getDate()).slice(-2);
                            rows[i].expiration_date = expiration_date;
                        }

                        if (typeof rows[i].temperature_range !== 'undefined') {
                            var temperature_range_arr = rows[i].temperature_range.split(':');
                            var temperature_range = temperature_range_arr[0].trim();
                            rows[i].temperature_range = temperature_range;
                        }

                        var validate = abcsetup.short_dated_opportunity.common.validateNewItem(rows[i]);

                        if (!validate.valid) {
                            abcsetup.alerts.show('Import Error', 'Please correct ' + validate.field + ' on line ' + (parseInt(i, 10)+2));
                            $('#opportunity-items-table tbody tr').remove();
                            $('.hidden-item-field').remove();
                            abcsetup.short_dated_opportunity.common.checkForItems();
                            return;
                        }

                        var ndc = '';
                        ndc_str_11 = rows[i].ndc;
                        console.log('ndc->'+rows[i].ndc);
                        if (ndc_str_11.length > 11) {
                            ndc_str_11 = ndc_str_11.replace(/\-/g, "");
                            if (ndc_str_11.length == 11) {
                                console.log('ndc11');
                                ndc = ndc_str_11;
                            }

                            ndc_str_10 = rows[i].ndc;
                            ndc_str_10 = ndc_str_10.replace(/[^0-9-]/, "");
                            if (ndc_str_10.match(/^\d{4}-\d{4}-\d{2}$/)) {
                                ndc = "0" + ndc_str_10.replace(/\-/g,"");
                            }
                            if (ndc_str_10.match(/^\d{5}-\d{3}-\d{2}$/)) {
                                ndc = ndc_str_10.substr(0, 5) + "0" + ndc_str_10.substr(6, 3) + ndc_str_10.substr(10, 2);
                            }
                            if (ndc_str_10.match(/^\d{5}-\d{4}-\d{1}$/)) {
                                ndc = ndc_str_10.substr(0, 5) + ndc_str_10.substr(6, 4)  + "0" + ndc_str_10.substr(11, 1);
                            }

                            rows[i].ndc = ndc;
                        }
                        else {
                            ndc = rows[i].ndc;
                        }

                        var product_name = rows[i].product_name;
                        var serialized = Object.keys(rows[i]).map(key => key + '=' + rows[i][key]).join('&');

                        abcsetup.short_dated_opportunity.common.addItemToForm(ndc, product_name, serialized, uid++);

                        ndc_count++;
                    }

                    if (ndc_count === 0) {
                        abcsetup.alerts.show('Import Error', 'No records containing a valid NDC were found in the import file.');
                    }
                }

                abcsetup.unblockUI();
            }, true);

            $("#import_short_dated_items_file").val('').trigger('change');
        });

        // Bind ndc so it can only accept numbers
        abcsetup.acceptNumbersOnly($('#ndc'));

        // Bind sap so it can only accept numbers
        abcsetup.acceptNumbersOnly($('#sap_num'));

         // Force decimals
         abcsetup.forceDecimal($('#height'), 2);
         abcsetup.forceDecimal($('#width'), 2);
         abcsetup.forceDecimal($('#depth'), 2);
         abcsetup.forceDecimal($('#weight'), 2);

        // NDC is not required (When checked, NDC and Item dimensions are not required)
        $('#new-short-dated-item-modal #ndc-not-required').on('click', e => {
            $('#new-short-dated-item-modal #ndc').parent().toggleClass('required', !e.target.checked);
            $('#new-short-dated-item-modal #ndc').prop('required', !e.target.checked);
        });

        // Information was added to the search field
        $('#new-short-dated-item-modal #new-short-dated-item-search').on('change', function(e){
            var id = $(this).val();
            abcsetup.short_dated_opportunity.common.populateFieldsFromSearch(id);
        });

         // Alcohol / 24+% check
         $('#alcohol').on('change', function(){
            // Delay so empty values from the autopop don't reset the 24% input
            setTimeout(() => {
                var twenty_four_percent_alcohol = $('#twenty_four_percent_alcohol');
                if ($(this).val().toUpperCase() === 'N') {
                    twenty_four_percent_alcohol.val('N').prop('disabled', true);
                } else {
                    twenty_four_percent_alcohol.val('').prop('disabled', false);
                }
            }, 250);
        });

        // Add item button from modal
        $("#add_update_item").on('click', function() {

            var form = $('#new-short-dated-item-modal form');
            var available_quantity = $('#new-short-dated-item-modal #available_quantity');
            var dnac_price = $('#new-short-dated-item-modal #dnac_price');
            var available_quantity_filled = true;
            var dnac_price_filled = true;

            // Check DNAC Price
            if (isNaN(dnac_price.val()) || dnac_price.val() == 0) {
                dnac_price_filled = false;
            }

            // Check Available Quantity
            if (isNaN(available_quantity.val()) || available_quantity.val() < 1) {
                available_quantity_filled = false;
            }

            if (!available_quantity_filled && dnac_price_filled) {
                if(!confirm('Are you sure you want to submit without an available quantity? Please add quantity if available')) {
                    available_quantity.trigger('focus');
                    return;
                }
            } else if (!dnac_price_filled && available_quantity_filled)  {
                if(!confirm('Are you sure you want to submit without a DNAC Price? Please add price if available')) {
                    dnac_price.trigger('focus');
                    return;
                }
            } else if (!dnac_price_filled && !available_quantity_filled) {
                if(!confirm('Are you sure you want to submit without a DNAC Price and Available Quantity? Please add price and quantity if available')) {
                    return;
                }
            }

            // Clear errors
            fieldValidate.removeOrnaments(form.find('.invalid'));

            // Check if overall form is valid
            var isValid = fieldValidate.checkValidity(form);

            if (!isValid) {
                form.find('.invalid:visible:first').trigger('focus');
                setTimeout(() => {
                    abcsetup.alerts.show('Form Validation', 'Form submission error. Please review the fields highlighted in red');
                }, 500);
                return;
            }

            // Valid form so remove disabled fields to allow for serialization
            form.find('[disabled]').prop('disabled', false);

            var uid = ($('#new-short-dated-item-modal #uid').val() !== '') ? $('#uid').val() : new Date().getTime();
            var ndc = $('#new-short-dated-item-modal #ndc').val();
            var product_name = $('#new-short-dated-item-modal #product_name').val();
            var serialized =  $('#new-short-dated-item-modal form').serialize();

            abcsetup.short_dated_opportunity.common.addItemToForm(ndc, product_name, serialized, uid);

            $('#new-short-dated-item-modal').modal('hide');
        });

        $(document).on('click', '.delete-item', function() {
            var removeRow = $(this).parents("tr");
            var dataID = $(this).data('id');
            abcsetup.alerts.confirm('Delete Item', 'Are you sure you want to delete this item?', function(confirm) {
                if (confirm) {
                    removeRow.remove();
                    $('#hidden-field-' + dataID).remove();
                    abcsetup.short_dated_opportunity.common.checkForItems();
                }
            })
        });

        // Table placeholder for when there are 0 items
        abcsetup.short_dated_opportunity.common.checkForItems();
    },

     /**
     *
     */
    resetModalForm: function(trigger_select2) {
        $('#new-short-dated-item-modal').find('.modal-body').scrollTop(0);
        $('#new-short-dated-item-modal').find('input, select').val('').prop('disabled', false).removeClass('disabled');
        $('#new-short-dated-item-modal').find('input:checkbox').prop('checked', false);

        if (!!trigger_select2) {
            $('#new-short-dated-item-search').empty().trigger('change');
        }
    },

    /**
     * Add an item the form
     *
     * @param int ndc
     * @param string product_name
     * @param string serialized
     * @param string uid (unique identifier)
     * @return void
     */
    addItemToForm: function(ndc, product_name, serialized, uid) {
        serialized += '&org_id='+abcsetup.userOrg.id+'&uid='+uid;

        var edit_button = '<button type="button" class="btn btn-primary btn-sm edit-item" data-id="'+uid+'"><i class="fas fa-edit mr-1"></i> Edit</button>';
        var delete_button = '<button type="button" class="btn btn-danger btn-sm delete-item" data-id="'+uid+'"><i class="fas fa-trash mr-1"></i> Delete</button>';
        var row = '<tr class="item" id="item-'+uid+'"><td nowrap>'+edit_button+' '+delete_button+'</td><td>' + ndc + '</td><td>' + product_name + '</td></tr>';

        if ($('#item-'+uid)[0]) {
             // Update
            $('#item-'+uid).replaceWith(row);
            $('#hidden-field-'+uid).val(serialized);
        } else {
            // New
            $("#opportunity-items-table tbody").append(row);
            $('#short_dated_form').append('<input type="hidden" class="hidden-item-field" name="items[]" id="hidden-field-'+uid+'" value="' + serialized + '">');
        }

        $('#ndc-not-required').prop('checked', false);
        abcsetup.short_dated_opportunity.common.checkForItems();
    },

    /**
     * Add an item the form
     *
     * @param int ndc
     * @param string product_name
     * @param string serialized
     * @param string uid (unique identifier)
     * @return void
     */
    sgsReview: function(ndc, product_name, serialized, uid) {
        serialized += '&org_id='+abcsetup.userOrg.id+'&uid='+uid;

        var edit_button = '<button type="button" class="btn btn-primary btn-sm edit-item" data-id="'+uid+'"><i class="fas fa-edit"></i> Edit</button>';
        var delete_button = '<button type="button" class="btn btn-danger btn-sm delete-item" data-id="'+uid+'"><i class="fas fa-trash"></i> Delete</button>';
        var row = '<tr class="item" id="item-'+uid+'"><td>'+edit_button+' '+delete_button+'</td><td>' + ndc + '</td><td>' + product_name + '</td></tr>';

        if ($('#item-'+uid)[0]) {
            // Update
            $('#item-'+uid).replaceWith(row);
            $('#hidden-field-'+uid).val(serialized);
        } else {
            // New
            $("#opportunity-items-table tbody").append(row);
            $('#short_dated_form').append('<input type="hidden" name="items[]" id="hidden-field-'+uid+'" value="' + serialized + '">');
        }


        abcsetup.short_dated_opportunity.common.checkForItems();
    },

    /**
     * Check if items exist in the table
     *
     * Add placeholder (perform other operations based on check)
     */
     checkForItems: function() {
        if ($('#opportunity-items-table tbody tr').length < 1) {
            $('#opportunity-items-table tbody#added_items').append('<tr class="no_item_placeholder"><td id="no_item_placeholder" colSpan="3" align="center">No items have been added.</td></tr>');
            $('#vendor-submitBtn').addClass('disabled').prop('disabled', true);
        } else {
            $('#opportunity-items-table .no_item_placeholder').remove();
            $('#vendor-submitBtn').removeClass('disabled').prop('disabled', false);
        }
    },


    /**
     * Enable button
     *
     * @param jQuery element
     * @return void
     */
     enableButton: function(element) {
        element.removeClass('disabled').prop('disabled', false);
    },

    /**
     * Disable button
     *
     * @param jQuery element
     * @return void
     */
     disableButton: function(element) {
        element.addClass('disabled').prop('disabled', true);
    },

    /**
     * Populate fields if applicable
     */
    populateFieldsFromSearch: function (id) {
        var route = '/api/autocomplete/items?c=id&q='+id;

        abcsetup.blockUI();

        axios.get(route).then(response => {
            var item = response.data;

            if (typeof item !== 'object') {
                abcsetup.unblockUI();
                return;
            }

            // Add RXItem data up a level in the item object to make the field mapping easier
            if (typeof item.rx_item === 'object' && item.rx_item !== null) {
                item.temp_range =  item.rx_item.temp_range ?? '';
                item.alcohol = item.rx_item.alcohol ?? '';
                item.alcohol_perc = item.rx_item.alcohol_perc ?? '';
                item.flammable = item.rx_item.flammable ?? '';
            }

            // Map fields: Key = database column, value = dom id
            var columnMap = {
                ndc11: 'ndc',
                sap_num: 'sap_num',
                name: 'product_name',
                form: 'form',
                item_height: 'height',
                item_width: 'width',
                item_depth: 'depth',
                item_weight: 'weight',
                temp_range: 'temperature_range',
                alcohol: 'alcohol',
                alcohol_perc: 'twenty_four_percent_alcohol',
                flammable: 'flammable_plastic',
            }

            // If we find a "valid" match from the DB populate and disable
            for (var column in columnMap) {
                var element = $('#new-short-dated-item-modal #'+columnMap[column]);
                element.prop('disabled', false).removeClass('disabled').val('');
                if (typeof item === 'object' && item.hasOwnProperty(column) && item[column] !== null && item[column] !== '') {
                    element.prop('disabled', true).addClass('disabled').val(item[column]).trigger('change');
                    // If an invalid value is sent to a select box it will then have an empty value
                    if (element[0].tagName.toLowerCase() === 'select') {
                        if (element.find(":selected").length === 0) {
                            element.prop('disabled', false);
                        }
                    }
                }
            }

            // Disable ndc not required toggle if a true ndc was found
            if ($('#ndc').prop('disabled') === true) {
                $('#ndc-not-required').prop('checked', false);
                $('#ndc-not-required').prop('disabled', true);
            } else {
                $('#ndc-not-required').prop('disabled', false);
            }

            abcsetup.unblockUI();
        });
    },


    // The order (indexing) must match the template file
    column_map : [
        'sap_num',
        'ndc',
        'ndc_not_established',
        'product_name',
        'form',
        'lot_number',
        'expiration_date',
        'available_quantity',
        'dnac_price',
        'returnable',
        'exclusive_opportunity',
        'weight',
        'depth',
        'width',
        'height',
        'flammable_plastic',
        'alcohol',
        'twenty_four_percent_alcohol',
        'temperature_range',
        'comments'
    ],

    // The order (indexing) must match the template file
    sgs_column_map : [
        'id',
        'short_dated_response_id',
        'status',
        'decline_reason',
    ],

    pricing_op_review_column_map : [
        'id',
        'supplier',
        'product_name',
        'sell_price',
        'premier_price',
        'hpg_price',
        'vizient_price',
        'pricing_team_comments',
    ],

    sgs_offer_letter_column_map : [
        'id',
        'product_name',
        'supplier',
        'short_dated_opportunity_id',
        'ndc',
        'sap_num',
        'distribution',
        'price',
        'wac_price',
        'quantity',
        'contract_chargeback',
        'contract_cost',
        'billback_purchase_credit',
        'chargeback',
        'buyside_fees',
        'payment_disc',
        'deadnet',
        'buy_request_date',
        'purchase_inventory',
        'note',
    ],

    sgs_pricing_review_column_map : [
        'id',
        'short_dated_response_id',
        'status',
        'decline_reason',
        'decline_reason_other',
        '',
        'product_name',
        'sell_price',
        'dnac_price',
        'pricing_team_comments',
        'price',
        'quantity',
    ],

    pricing_column_map : [
        'id',
        'supplier',
        'product_name',
        'ndc',
        'sap_num',
        'form',
        'lot_number',
        'expiration_date',
        'dnac_price',
        'available_quantity',
        'returnable',
        'exclusive_opportunity',
        'weight',
        '',
        'flammable_plastic',
        'alcohol',
        'twenty_four_percent_alcohol',
        '',
        'buy_price',
        'sell_price',
        'pricing_team_comments',
        ''
    ],

    rx_vendor_counter_review_column_map : [
        'id',
        'product_name',
        'ndc',
        'form',
        'lot_number',
        'counter_options',
        // 'previous_price',
        'dnac_price',
        'proposed_price',
        'counter_price',
        // 'previous_quantity',
        'available_quantity',
        'proposed_quantity',
        'counter_quantity',
        'updated_at',
        'vendor_comments',
    ],

    validateNewItem: function(item) {

        // SAP
        // if (!item.hasOwnProperty('sap_num') || isNaN(parseInt(item.sap_num)) || parseInt(item.sap_num) <= 0) {
        //     return { 'valid' : false, 'field' : 'SAP' };
        // }

        // NDC
        if ((!item.hasOwnProperty('ndc') || isNaN(parseInt(item.ndc)) || parseInt(item.ndc) <= 0) && (item.ndc_not_established === 'No')) {
            return {'valid': false, 'field': 'NDC'};
        }


        // Product Name
        if (!item.hasOwnProperty('product_name') || product_name.length < 1) {
            return { 'valid' : false, 'field' : 'Product Name' };
        }

        // Form
        // if (!item.hasOwnProperty('form') || product_name.length < 1) {
        //     return { 'valid' : false, 'field' : 'Form' };
        // }

        // Lot Number
        // if (!item.hasOwnProperty('lot_number')) {
        //     return { 'valid' : false, 'field' : 'Lot Number' };
        // }

        if (item.ndc.length > 0) {
            // Expiration Date
            var regex = /^\d{4}\-(0[1-9]|1[012])\-(0[1-9]|[12][0-9]|3[01])$/;
            var d = new Date();
            var month = d.getMonth() + 1;
            var day = d.getDate();
            var output = d.getFullYear() + '-' +
                (('' + month).length < 2 ? '0' : '') + month + '-' +
                (('' + day).length < 2 ? '0' : '') + day;
            if (!item.hasOwnProperty('expiration_date') || !regex.test(item.expiration_date) || (item.expiration_date < output)) {
                return { 'valid' : false, 'field' : 'Expiration Date' };
            }


            // Available Quantity
            // if (!item.hasOwnProperty('available_quantity') || isNaN(parseInt(item.available_quantity)) || parseInt(item.available_quantity) <= 0) {
            //     return { 'valid' : false, 'field' : 'Available Quantity' };
            // }

            // Proposed DNAC Price
            // if (!item.hasOwnProperty('dnac_price') || isNaN(parseFloat(item.ndc)) || parseFloat(item.ndc) <= 0) {
            //     return { 'valid' : false, 'field' : 'Proposed DNAC Price' };
            // }

            // Returnability
            if (!item.hasOwnProperty('returnable') || (['Y', 'N'].indexOf(item.returnable) === -1)) {
                return { 'valid' : false, 'field' : 'Returnability' };
            }

            // AB-Exclusive Opportunity?
            if (!item.hasOwnProperty('exclusive_opportunity') || (['Y', 'N'].indexOf(item.exclusive_opportunity) === -1)) {
                return { 'valid' : false, 'field' : 'COR-Exclusive Opportunity?' };
            }

            // Weight (lb)
            // if (!item.hasOwnProperty('weight') || isNaN(parseFloat(item.weight)) || parseFloat(item.weight) <= 0) {
            //     return { 'valid' : false, 'field' : 'Weight (lb)' };
            // }

            // Length (in)
            // if (!item.hasOwnProperty('depth') || isNaN(parseFloat(item.depth)) || parseFloat(item.depth) <= 0) {
            //     return { 'valid' : false, 'field' : 'Length (in)' };
            // }

            // Width (in)
            // if (!item.hasOwnProperty('width') || isNaN(parseFloat(item.width)) || parseFloat(item.width) <= 0) {
            //     return { 'valid' : false, 'field' : 'Width (in)' };
            // }

            // Height (in)
            // if (!item.hasOwnProperty('height') || isNaN(parseFloat(item.height)) || parseFloat(item.height) <= 0) {
            //     return { 'valid' : false, 'field' : 'Height (in)' };
            // }

            // Flammable Plastic?
            // if (!item.hasOwnProperty('flammable_plastic') || (['Y', 'N'].indexOf(item.flammable_plastic) === -1)) {
            //     return { 'valid' : false, 'field' : 'Flammable Plastic?' };
            // }

            // Does this item contain alcohol?
            // if (!item.hasOwnProperty('alcohol') || (['Y', 'N'].indexOf(item.alcohol) === -1)) {
            //     return { 'valid' : false, 'field' : 'Does this item contain alcohol?' };
            // }

            // Does the item contain 24% or more alcohol?
            // if (!item.hasOwnProperty('twenty_four_percent_alcohol') || (['Y', 'N'].indexOf(item.twenty_four_percent_alcohol) === -1)) {
            //     return { 'valid' : false, 'field' : 'Does the item contain 24% or more alcohol?' };
            // }

            // Temperature Range
            // if (!item.hasOwnProperty('temperature_range') || (['40', '41', '30', '20', '10', '21'].indexOf(item.temperature_range.toString()) === -1)) {
            //     return { 'valid' : false, 'field' : 'Temperature Range' };
            // }
        }


        return { 'valid' : true };
    },

    validateSGSNewItem: function(item) {

        // Status
        if (!item.hasOwnProperty('status')) {
            return { 'valid' : false, 'field' : 'Status' };
        }

        return { 'valid' : true };
    },

    /**
     * fieldError callback from _jquery.fieldValidate
     */
    fieldError: function () {
        $('form#short_dated_form')
            .find('.invalid')
            .each(function() {
                console.log('field: ', this, this.validationMessage)
            });
    },
}
